<template>
  <div>{{ message }}</div>
</template>

<script>
export default {
  data() {
    return {
      message: 'Redirecting to import trip...'
    };
  },
  created() {
    const importId = this.$route.params.id
    const onImport = localStorage.getItem('onImport') === 'true';
    if (onImport) {
      this.message = `Trip with the id: ${localStorage.getItem('autoImportId')} is already imported`;
    }else{
      localStorage.setItem('onImport', true);
      localStorage.setItem('autoImportId', importId)
      // Slight delay before redirecting to ensure it's saved
      setTimeout(() => {
        this.$router.push('/trips')
      }, 100)
    }
  }
}
</script>
